import styled, { css } from "styled-components";

const commonStyles = css`
  width: 150rem;
  max-width: 90vw;
  .informacoes {
    text-wrap: nowrap;
    display: grid;
    grid-template-columns: 1fr;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    gap: 2rem;
    position: relative;
    padding-bottom: 2rem;

    @media(min-width: 768px){
      grid-template-columns: repeat(2, 1fr);
    }

    .tituloContainer{
      margin-bottom: 5rem;
      .titulo{
        padding: 0;
      }
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 40rem;
      height: 2px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      background-color: ${(props) => props.theme.colors.elements};
      border-radius: 50px;
    }
    
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
      
    }
  }

  .configuracoesFotos{
    width: 90%;
    padding-top: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;

    .tituloConfig{
      font-weight: 700;
      color: ${(props) => props.theme.colors.tertiary};
      text-align: left;
      width: 90%;
    }

    .togglesContainer{
      width: 90%;
      display: flex;
      flex-direction: column;
      gap: 2rem;
      > .toggleContainer {
        display: flex;
        align-items: center;
        color: ${(props) => props.theme.colors.tertiary};
        gap: 1rem;

        span {
          text-align: justify;
        }

        .info-icon-container {
          position: relative;
          display: flex;
          align-items: center;

          svg {
            fill: ${(props) => props.theme.colors.tertiary};
            opacity: 0.7;
            transition: opacity 0.2s;
            &:hover {
              opacity: 1;
            }
          }

          .preview-tooltip {
            position: absolute;
            bottom: calc(100% + 10px);
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 1.5rem;
            padding: 1.5rem;
            background-color: ${(props) => props.theme.colors.elements};
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            z-index: 100;
            white-space: nowrap;

            @media (max-width: 768px) {
              left: auto;
              right: 0;
              transform: none;
            }

            &::after {
              content: "";
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              border: 8px solid transparent;
              border-top-color: ${(props) => props.theme.colors.elements};

              @media (max-width: 768px) {
                left: auto;
                right: 10px;
                transform: none;
              }
            }

            .preview-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 0.5rem;

              img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                border-radius: 8px;
              }

              span {
                font-size: 12px;
                color: ${(props) => props.theme.colors.tertiary};
              }
            }
          }
        }
      }
    }
  }
`;

export const ContainerVisualContainer = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles};
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      width: 100%;
      max-width: 100%;
      margin-top: 5rem;
      .informacoes {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
        width: 100%;
        max-width: 100%;
        &::after {
          display: none;
        }
        @media (max-width: 768px) {
          grid-template-columns: repeat(auto-fit, minmax(32rem, 1fr));
        }
      }
      .configuracoesFotos{
        width: 100%;

        .tituloConfig{
          width: 100%;
        }

        .togglesContainer{
          width: 100%;
        }
      }
  `};
`;
